import React from 'react';
export const Card = ({ children, className = '' }) => {
  return (
    <div className={`bg-white rounded-xl border border-slate-100 shadow-slick p-6 ${className}`}>
      {children}
    </div>
  );
};
